export class SmsLog
{
    public refId: string;
    public type: string;
    public content: string;
    public created: string;
    public updated: string;
}